import React, { useRef, useState } from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { uploadToS3 } from "features/Common/modules/S3/utils/S3.utils";
import { ACCEPTED_FILE_TYPES } from "ui/pages/whatsappBroadcast/whatsappBroadcast.constants";
import { notification_color_keys, useNotifications } from "utils/hooks";
import { logError } from "utils/error";
import { useUpload } from "hooks/useUpload";

export const UploadFileButton = ({
  btnText = "Upload file",
  startIcon: Icon,
  accept = "application/pdf",
  disabled = false,
  className = "",
  baseFilePath = "",
  onSuccess = () => {},
}) => {
  const { notify } = useNotifications();
  const isDesktop = useDesktopMediaQuery();
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const { getPublicCdnUrl } = useUpload();

  const handleClick = () => {
    if (disabled || isUploading) return;

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleUploadPdf = async (file) => {
    try {
      if (!file) return;
      setIsUploading(true);

      if (file.type !== ACCEPTED_FILE_TYPES.PDF) {
        notify("Only PDF files are allowed", notification_color_keys.error);
        setIsUploading(false);
        return;
      }

      const key = `${baseFilePath}/${Date.now()}.pdf`;
      const bucket = process.env.REACT_APP_S3_BUCKET_EXLY_CONTENT;
      const apiResponse = await uploadToS3({
        file,
        contentType: file.type,
        key,
        bucket,
      });

      const fileLocation = apiResponse?.Location;
      if (!fileLocation) {
        throw new Error("S3 upload failed");
      }

      const url = getPublicCdnUrl({
        key,
        bucket,
      });

      onSuccess(url, "Pdf File");
    } catch (error) {
      logError({
        error,
        occuredAt:
          "src/features/ManageOfferings/modules/UploadFileButton/UploadFileButton.jsx",
        when: "handleUploadPdf",
      });
      notify(
        "Failed to upload document. Please try again.",
        notification_color_keys.error
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    handleUploadPdf(file);
    e.target.value = "";
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        disabled={isUploading}
        className="tw-hidden"
        onChange={handleFileChange}
      />

      <Button
        variant="outlined"
        color="secondary"
        disabled={disabled || isUploading}
        className={
          className || `!tw-h-[32px] ${isDesktop ? "!tw-text-[14px]" : ""}`
        }
        {...(!isUploading && Icon
          ? {
              startIcon: (
                <Icon className={isDesktop ? "tw-w-[18px] tw-h-[18px]" : ""} />
              ),
            }
          : {})}
        onClick={handleClick}
      >
        {isUploading ? "Uploading..." : btnText}
      </Button>
    </>
  );
};
